// A very quiet two-note café door chime, synthesised so there's no audio file.
// Browsers only allow sound after a user gesture, so unlockChime() is called
// when the user presses enter; playChime() does nothing until then.

let ctx: AudioContext | null = null;

export const unlockChime = () => {
  try {
    ctx ??= new AudioContext();
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  } catch {
    ctx = null; // No Web Audio: arrivals stay silent
  }
};

// One soft bell tone: a sine with a quieter octave partial, fast attack and a
// long exponential fade, low-passed so it never sounds sharp
const bell = (c: AudioContext, freq: number, at: number, peak: number) => {
  const filter = c.createBiquadFilter();
  filter.type = 'lowpass';
  filter.frequency.value = 2400;
  filter.connect(c.destination);

  const env = c.createGain();
  env.gain.setValueAtTime(0, at);
  env.gain.linearRampToValueAtTime(peak, at + 0.015);
  env.gain.exponentialRampToValueAtTime(0.0001, at + 1.8);
  env.connect(filter);

  for (const [mult, level] of [[1, 1], [2, 0.18]] as const) {
    const osc = c.createOscillator();
    const partial = c.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq * mult;
    partial.gain.value = level;
    osc.connect(partial).connect(env);
    osc.start(at);
    osc.stop(at + 1.9);
  }
};

/** E5 then C5, like a café door bell heard from across the room */
export const playChime = (volume = 0.04) => {
  if (!ctx || ctx.state !== 'running') return;
  const t = ctx.currentTime + 0.02;
  bell(ctx, 659.25, t, volume);
  bell(ctx, 523.25, t + 0.18, volume * 0.85);
};
